import React, { ReactNode } from 'react';
import useStyle from './featureContainer.style';
import { classNames } from '../../../../helpers/style/classNames';

export interface FeatureContainerProps {
  buttonWithText?: JSX.Element;
  iconButton?: JSX.Element;
  buttonPosition?: 'bottomRight' | 'bottomMiddle' | 'topRight';
  backgroundImage?: string;
  padding?: 'default' | 'small' | 'dashboardChart' | 'mobileTab';
  children: ReactNode;
  withPadding?: boolean;
}

export const FeatureContainer = ({
  buttonWithText,
  iconButton,
  buttonPosition = 'bottomMiddle',
  backgroundImage,
  padding = 'default',
  children,
  withPadding = true
}: FeatureContainerProps) => {
  const classes = useStyle();

  return (
    <div
      className={classNames(
        [classes.root, classes[padding]],
        [
          {
            condition:
              (buttonWithText || iconButton) &&
              buttonPosition === 'bottomRight' &&
              withPadding,
            classe: classes.paddingbottomRight
          },
          {
            condition:
              (buttonWithText || iconButton) &&
              buttonPosition === 'topRight' &&
              withPadding,
            classe: classes.paddingtopRight
          }
        ]
      )}
    >
      {children}
      {(buttonWithText || iconButton) && (
        <div
          className={classNames(
            [classes.infoButton],
            [
              {
                condition: buttonPosition === 'bottomRight',
                classe: classes.bottomRight
              },
              {
                condition: buttonPosition === 'topRight',
                classe: classes.topRight
              },
              {
                condition: buttonPosition === 'bottomMiddle',
                classe: classes.bottomMiddle
              }
            ]
          )}
        >
          {buttonWithText && buttonWithText}
          {iconButton && iconButton}
        </div>
      )}
      {backgroundImage && (
        <img
          className={classes.background}
          src={backgroundImage}
          alt="background"
        />
      )}
    </div>
  );
};
